import { controls } from "../controls";


const tr051 = {
  label: "Standing Instruction Execution",
  pageLabel: "Standing Instruction Execution",
  starting: true,
  url: "tr051",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region", width: "col-sm-2" }),
    ...controls.Region({ tab: "filter" }),
    ...controls.showData({ tab: "filter", name: "region_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Product", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", label: "From To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "from_date", width: "col-sm-2", }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "to_date", width: "col-sm-2", default: "sessiondate" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "Upto Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "upto_date", width: "col-sm-2", default: "sessiondate" }),

    ...controls.radio({ width: "col-sm-3", name: "cdflag", cwidth: "col-sm-4", options: [{ label: "Trial", value: "trial" }, { label: "Post", value: "post" }], clearChildren: [{}] }),

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Srno",
        accessor: "srno",
        width: 150
      },
      {
        Header: "Account Number",
        accessor: "account_no",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
        width: 150
      },
      {
        Header: "Name",
        accessor: "full_name",
        width: 150
      },

      {
        Header: "Int Flag",
        accessor: "int_flag",
        width: 150
      },
      {
        Header: "Balance",
        accessor: "balance",
        width: 150
      },
      {
        Header: "Balance",
        accessor: "balance",
        width: 150
      },
      {
        Header: "Credit",
        accessor: "credit",
        width: 150
      },
      {
        Header: "Debit",
        accessor: "debit",
        width: 150
      },
      {
        Header: "Int Date",
        accessor: "int_date",
        width: 150
      },
      {
        Header: "Int Rate",
        accessor: "int_rate",
        width: 150
      },



    ]
  }
}
export default tr051